module.exports = __webpack_public_path__ + "images/instructor-davis-balaba-mobile.webp";